<script>
import { Carousel, Slide } from "vue-carousel";
import DatePicker from "vue2-datepicker";

export default {
    name: "FinanceOverviewReports",
    components: {
        Carousel,
        Slide,
        DatePicker
    },
    props: {
        fundClusters: {
            type: Array,
            required: false,
            default: () => [],
        },
        months: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            reportList: false,
            slideNum: 1,
            selectedMonth: new Date().getMonth() + 1,
            selectedFundCluster: null,
            selectedOption: null,
            selectedDateFrom: new Date(),
            selectedDateTo: new Date(),
        };
    },
    computed: {
        hasDateSelection(){
            return ['disbursementreport', 'checksissued', 'adaissued'].includes(this.selectedOption);
        },
    },
    methods: {
        selectOptions(option) {
            this.selectedOption = option;
            this.slideNum = 2;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
        },
        goBack() {
            this.slideNum = 1;
            this.$refs.carousel.goToPage(0);
        },
        generateReport(){
            const reportParams = {
                month: this.selectedMonth,
                fundCluster: this.selectedFundCluster,
                selectedOption: this.selectedOption,
                from: this.getDate(this.selectedDateFrom),
                to: this.getDate(this.selectedDateTo),
            };
            this.$emit('generate-report', reportParams);
        },
    },
};
</script>
<template>
    <div>
        <b-button id="finance-select-report" variant="purple">
            <i class="bx bx-printer align-middle me-2"></i>Reports
        </b-button>
        <b-popover
            target="finance-select-report"
            triggers="click"
            placement="left"
            :show.sync="reportList"
        >
            <template v-slot:title>
                <div class="d-flex align-items-center justify-content-between">
                    <small>Report List</small>
                    <span 
                        class="bx bx-x font-size-14 cursor-pointer"
                        @click="reportList = false"
                    ></span>
                </div>
            </template>
            <carousel
                ref="carousel"
                class="events navs-carousel custom-carousel"
                id="timeline-carousel"
                :navigation-enabled="false"
                :pagination-enabled="false"
                :perPage="1"
                :autoplay="false"
                :minSwipeDistance="0"
                :mouseDrag="false"
            >
                <slide class="p-0">
                    <div v-if="slideNum == 1">
                        <div>
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('cf')"
                                    class="font-size-12 text-dark hoverable-link"
                                >
                                    Cash Flow
                                </a>
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('tb')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Trial Balance</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <!-- <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('gj')"
                                    class="font-size-12 text-dark hoverable-link"
                                >General Journal</a
                                >
                            </div>
                            <hr class="my-1 " /> -->
                            <!-- <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('gl')"
                                    class="font-size-12 text-dark hoverable-link"
                                >General Ledger</a
                                >
                            </div>
                            <hr class="my-1 " /> -->
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('is')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Income Statement</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('dis')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Detailed Income Statement</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('bs')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Balance Sheet</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('dbs')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Detailed Balance Sheet</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('coh')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Cash on Hand</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('disbursementreport')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Disbursement Report</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('checksissued')"
                                    class="font-size-12 text-dark hoverable-link"
                                >Checks Issued</a
                                >
                            </div>
                            <hr class="my-1 " />
                            <div class="mb-0">
                                <a
                                    href="javascript:void(0);"
                                    role="button"
                                    @click="selectOptions('adaissued')"
                                    class="font-size-12 text-dark hoverable-link"
                                >ADA Issued</a
                                >
                            </div>
                        </div>
                    </div>
                </slide>
                <slide class="p-0">
                    <div v-if="slideNum == 2">
                        <div class="my-3">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary"
                                    @click="goBack()"
                                >
                                    <i class="bx bx-chevron-left"></i> Back
                                </button>
                            </div>
                            <div class=" mb-3" v-if="!hasDateSelection">
                                <label for="monthSelect" class="mb-0">Select Month</label>
                                <select 
                                    class="form-select"
                                    v-model="selectedMonth"
                                >
                                    <option value="">Select a month</option>
                                    <option 
                                        v-for="month in months" 
                                        :key="month.value"
                                        :value="month.value"
                                    >
                                        {{ month.text }}
                                    </option>
                                </select>
                            </div>
                            <template v-if="hasDateSelection">
                                <div class="mb-3" >
                                    <label for="date" class="mb-0">From</label>
                                    <date-picker
                                        id="dateFrom"
                                        v-model="selectedDateFrom"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="Enter Date..."
                                    >
                                    </date-picker>
                                </div>
                                <div class="mb-3" >
                                    <label for="date" class="mb-0">To</label>
                                    <date-picker
                                        id="dateTo"
                                        v-model="selectedDateTo"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="Enter Date..."
                                    >
                                    </date-picker>
                                </div>
                            </template>
                            <div class=" mb-3" v-if="selectedOption !== 'disbursementreport'">
                                <label for="fcSelect" class="mb-0">Select Fund Cluster</label>
                                <select 
                                    class="form-select"
                                    v-model="selectedFundCluster"
                                >
                                    <option 
                                        v-for="fundCluster in fundClusters" 
                                        :key="fundCluster.value"
                                        :value="fundCluster.value"
                                    >
                                        {{ fundCluster.text }}
                                    </option>
                                </select>
                            </div>
                            <div class=" mb-3">
                                <button 
                                    class="btn btn-purple w-100"
                                    @click="generateReport()"
                                >
                                    <i class="bx bx-printer"></i> Generate Report
                                </button>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>
        </b-popover>
    </div>
</template>